import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  createOnlineOrderRequest,
  createOnlineOrderSuccess,
  createOnlineOrderFailure,
  verifyOnlineOrderRequest,
  verifyOnlineOrderSuccess,
  verifyOnlineOrderFailure,
} from "./onlineOrderSlice";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const TOKEN = process.env.REACT_APP_PUBLIC_TOKEN;

function createOrderAPI(payload) {
  const origin = window.location.origin;
  const returnUrl = `${origin}/PaymentVerify`;
  return axios.post(
    `${BASE_URL}/api/v1/transactions/createOrder`,
    {
      ...payload,
      returnUrl,
      webhookUrl: `${origin}/webhookUrl`,
    },
    {
      headers: {
        Authorization: TOKEN,
        "Content-Type": "application/json",
        version: "1.2.0",
        newui: "true",
      },
    },
  );
}

function verifyOrderAPI(payload) {
  return axios.post(`${BASE_URL}/api/v1/transactions/verifyPayment`, payload, {
    headers: {
      Authorization: TOKEN,
      "Content-Type": "application/json",
      version: "1.2.0",
      newui: "true",
    },
  });
}

function* createOrderSaga(action) {
  try {
    const { data } = yield call(createOrderAPI, action.payload);
    yield put(createOnlineOrderSuccess(data));
  } catch (error) {
    yield put(createOnlineOrderFailure(error.response?.data || error.message));
  }
}

function* verifyOrderSaga(action) {
  try {
    const { data } = yield call(verifyOrderAPI, action.payload);
    yield put(verifyOnlineOrderSuccess(data));
  } catch (error) {
    yield put(verifyOnlineOrderFailure(error.response?.data || error.message));
  }
}

export default function* onlineOrderSaga() {
  yield takeLatest(createOnlineOrderRequest.type, createOrderSaga);
  yield takeLatest(verifyOnlineOrderRequest.type, verifyOrderSaga);
}
